<template>
    <li class="nav-item dropdown nav-item-box">
      <a href="#" class="nav-link" data-bs-toggle="dropdown" @click="markAllAsSeen">
        <i class="ti ti-bell"></i>
        <span class="badge rounded-pill" v-if="unreadNotificationCount">{{ unreadNotificationCount }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-end notification-dropdown">
        <div class="topnav-dropdown-header">
          <h4 class="notification-title">Notifications</h4>
        </div>
        <div class="noti-content">
          <!-- <ul class="notification-list">
            <li v-for="notification in notifications" :key="notification.id" class="notification-message">
              <a href="#" @click.prevent="handleNotification(notification)">
                <div class="media d-flex">
                    <span class="avatar flex-shrink-0">
                        <i class="fas fa-user-circle" style="font-size: 24px; color: #6c757d;"></i>
                    </span>
                  <div class="media-body flex-grow-1">
                    <p class="noti-details">
                        Request for {{ notification.permission_type }} access to the lead: {{ notification?.lead?.initial_info?.organization_name }} by {{ notification?.employee?.user?.name }}
                    </p>
                    <p class="noti-time">{{ formatDate(notification.created_at) }}</p>
                  </div>
                </div>
              </a>
            </li>
          </ul> -->

          <ul class="notification-list">
            <li v-for="notification in allNotifications" :key="notification.id" 
              :class="{'unread': !notification.is_read}" class="notification-message">
              <a href="#" @click.prevent="handleNotification(notification)">
                <div class="media d-flex">
                  <span class="avatar flex-shrink-0">
                    <i class="fas fa-user-circle" style="font-size: 24px; color: #6c757d;"></i>
                  </span>
                  <div class="media-body flex-grow-1">
                    <p class="noti-details">{{ notification.message }}</p>
                    <p class="noti-time">{{ formatDate(notification.created_at) }}</p>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="topnav-dropdown-footer">
          <router-link to="/leads-edit-requests" class="view-link">View all</router-link>
          <a href="#" class="clear-link" @click="clearAllNotifications">Clear all</a>
        </div>
      </div>
    </li>
  </template>
  
  <script>
   import http from "@/utils/http";
  import Swal from "sweetalert2";
  import {mapGetters} from "vuex";
  
  export default {
    data() {
      return {
        notifications: [],
        // allNotifications: [],
      };
    },
    async created() {
      await this.fetchNotifications();
    },
    computed: {
        ...mapGetters(["supervisorNotification"]),

        allNotifications() {
          const assignedNotifications = this.notifications.map(notification => ({
              id: notification.id,
              created_at: notification.created_at,
              is_read: notification.is_read,
              type: "assigned_employee",
              message: notification.assigned_type === "additional_employee"
                  ? `You have been assigned as an additional employee to the exhibition - ${notification.exhibition.name} for lead - ${notification.lead.initial_info.organization_name}`
                  : `You have been assigned as an employee to the exhibition - ${notification.exhibition.name} for lead - ${notification.lead.initial_info.organization_name}`,
          }));

          const existingNotifications = this.supervisorNotification
              .filter(n => n.status === "pending")
              .map(n => ({
                  ...n,
                  type: "supervisor_notification",
                  message: `Request for ${n.permission_type} access to lead: ${n?.lead?.initial_info?.organization_name} by ${n?.employee?.user?.name}`,
              }));

          return [...assignedNotifications, ...existingNotifications].sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
      },

        unreadNotificationCount() {
          return this.allNotifications.filter(n => !n.is_read).length;
        }
    },
    methods: {
      async fetchNotifications() {
        try {
            const response = await http.get(`/assigned-employee-notifications`);
            this.notifications = response.data.contents.map(notification => ({
                id: notification.id,
                created_at: notification.created_at,
                is_read: notification.is_read,
                assigned_type: notification.assigned_type,
                exhibition: notification.exhibition,
                lead: notification.lead,
            }));
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
      },

      async handleNotification(notification) {
        if (notification.type === "supervisor_notification") {
          const result = await Swal.fire({
            title: "Approve or Reject?",
            text: `Do you want to approve or reject the edit request for lead ${notification?.lead?.initial_info?.organization_name}?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Approve",
            cancelButtonText: "Reject",
          });
    
          if (result.isConfirmed) {
            await this.approveRequest(notification.id, notification.permission_type);
          } 
          else if (result.dismiss !== Swal.DismissReason.backdrop && result.dismiss !== Swal.DismissReason.esc) {
              await this.rejectRequest(notification.id, notification.permission_type);
          }
        }
        else if (notification.type === "assigned_employee") {
          await this.markAsRead(notification);
        }
      },

      async markAsRead(notification) {
        const endpoint = "/mark-notification-read";
        const method = "post";
        let body = {
          id: notification.id,
        };
        try {
          const response = await http[method](endpoint, body);
          this.$toast.success(response.data.message);
          // this.allNotifications = this.allNotifications.map(n => 
          //   n.id === notification.id ? { ...n, is_read: true } : n
          // );

          this.notifications = this.notifications.map(n =>
            n.id === notification.id ? { ...n, is_read: true } : n
          );
        } catch (error) {
          if (error.response && error.response.data) {
            if (error.response.data.message) {
              this.$toast.error(error.response.data.message);
            }
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
          } else {
            this.$toast.error("An unexpected error occurred. Please try again.");
          }
        } finally {
          this.isLoading = false;
        }
      },

      async approveRequest(requestId, permissionType) {
        const endpoint = "/leads-edit-request-action";
        const method = "post";
        let body = {
            id: requestId,
            actionType: 'approved',
            permissionType: permissionType
        };
        try {
            const response = await http[method](endpoint, body);
            this.$toast.success(response.data.message);
            this.$store.commit("updateSupervisorNotification", response.data.notification);

            // this.$store.commit('setSupervisorNotifications', response.data.notification);
        } catch (error) {
            // this.$toast.error(error.response.data.message);
        } 
        finally {
          //
        }
      },
      async rejectRequest(requestId, permissionType) {
        const endpoint = "/leads-edit-request-action";
        const method = "post";
        let body = {
            id: requestId,
            actionType: 'reject',
            permissionType: permissionType
        };
        try {
            const response = await http[method](endpoint, body);
            this.$toast.success(response.data.message);
            this.$store.commit("updateSupervisorNotification", response.data.notification);
        } catch (error) {
            this.$toast.error(error.response.data.message);
        } 
        finally {
          //
        }
      },

      clearAllNotifications() {
        this.notifications = [];
      },
      formatDate(date) {
        return new Date(date).toLocaleString();
      },
    },
  };
  </script>
  
<style scoped>
.unread {
    background-color: #f8d7da;
    font-weight: bold;
}

.notification-message {
    padding: 10px;
    cursor: pointer;
}

.notification-message:hover {
    background-color: #f1f1f1;
}

.noti-content {
  max-height: 400px;
  overflow-y: auto;
}

.noti-content::-webkit-scrollbar {
  width: 8px;
}

.noti-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.noti-content::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>